export default [
    {
        path: "/nvaie",
        name: "NVAIE",
        component: () => import("@/views/nvaie"),
        meta: {title: "NVAIE", activeMenu: "/nvaie"},
    },
]
